<template>
  <div>
    <hshead title="约拍城市" waveBg="true"></hshead>
    <div class="city-top" v-if="shootCitysAuditStatisticsData">
      <div class="top-left">
        <div class="this-p">已通过：{{shootCitysAuditStatisticsData.total_Pass}}</div>
        <div class="this-p">审核中：{{shootCitysAuditStatisticsData.total_Auditting}}</div>
      </div>
      <div class="top-right">
        <div class="this-img">
          <img src="~@/assets/images/city/city.png" alt />
        </div>
        <router-link to="/Grapher/ApplicantCity" class="this-btn">申请约拍城市</router-link>
      </div>
    </div>
    <div class="city-ul">
      <van-list v-model="loadingByShootCitys" :finished="finishedByShootCitys" finished-text="" @load="onLoad">
        <div class="city-li" v-for="(item, index) in listByShootCitys" :key="index">
          <div class="left-icon">
            <img src="~@/assets/images/city/tempCity.png" alt />
          </div>
          <div class="center-p">
            <div class="center-h1" v-if="item.provinceId=='*'&&item.cityId=='*'">中国</div>
            <div class="center-h1" v-else>{{item.provinceName}} {{item.cityName}}</div>
            <div class="center-time">{{item.createTime}}</div>
          </div>
          <div class="right-icon" v-if="item.status==1">
            <img src="~@/assets/images/city/icon-doing.png" alt='未审核' />
          </div>
          <div class="right-icon" v-if="item.status==2">
            <img src="~@/assets/images/city/icon.png" alt='审核通过' />
          </div>
          <div class="right-icon" v-else-if="item.status==3">
            <img src="~@/assets/images/city/icon-no.png" alt='审核不通过' />
          </div>
        </div>
      </van-list>
      <div v-if="finishedByShootCitys" class="emptyDataDiv_gray">
        <div v-if="listByShootCitys.length==0">
          <van-icon name="info" />
          <p>没有数据</p>
        </div>
        <div v-else>没有更多了</div>
      </div>
    </div>
  </div>
</template>

<script>

import hshead from "@/components/common/hshead";
import { Toast, List } from "vant";
import { getPagerByGrapher as getShootCityPager, getAuditCityStatisticsByGrapher } from "@/api/m/shootCity";

export default {
  name: "city",
  data() {
    return {
      //约拍城市
      shootCitysAuditStatisticsData:  null,
      listByShootCitys: [],
      loadingByShootCitys: false,
      finishedByShootCitys: false,
      listQueryByShootCitys: {
        pn: 1,
        ps: 20,
      },
    };
  },
  created() {
    console.info('获取约拍城市统计信息')
    //获取约拍城市统计信息
    this.getAuditCityStatisticsByGrapher()
  },
  methods: {
    onLoad() {
      this.getShootCityPager();
    },
    //获取约拍城市统计信息
    getAuditCityStatisticsByGrapher() {
      this.load(true, '加载中...');
      getAuditCityStatisticsByGrapher().then(response => {
        this.load(false);
        const { code, msg, data } = response;
        if (code >= 0) {
          this.shootCitysAuditStatisticsData = data
        }
      }).catch(response => {
        this.load(false);
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
    //约拍城市列表数据
    getShootCityPager() {
      getShootCityPager(this.listQueryByShootCitys).then(response => {
        this.load(false);
        console.info('response', response)
        const { code, msg, data } = response;
        if (code >= 0) {
          console.info('getShootCityPager -> data', data)
          this.listQueryByShootCitys.pn = this.listQueryByShootCitys.pn + 1
          //
          if(data.totalRecord == 0){
            this.loadingByShootCitys = false;
            this.finishedByShootCitys = true;
          }
          else {
            data.list.map(item => {
              this.listByShootCitys.push(item)
            })
            // 加载状态结束
            this.loadingByShootCitys = false;
            // 数据全部加载完成
            if (this.listByShootCitys.length >= data.totalRecord) {
              this.finishedByShootCitys = true;
            }
          }
        }
      })
      .catch(response => {
        this.load(false);
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
  },
  components: {
    hshead,
    "van-list": List
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.city-top {
  display: flex;
  margin-top: -3.5rem;
  .top-left {
    width: 3.41rem;
    height: 1.04rem;
    border-right: 1px solid rgba(255, 255, 255, 0.6);
    .this-p {
      font-family: PingFang-SC-Medium;
      font-size: 0.3rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #ffffff;
      padding-left: 1rem;
      padding-top: 0.15rem;
    }
  }
  .top-right {
    flex: 1;
    display: flex;
    .this-img {
      width: 1.9rem;
      text-align: center;
      img {
        width: 0.83rem;
        height: 0.87rem;
        display: inline-block;
      }
    }
    .this-btn {
      display: block;
      text-align: center;
      margin-top: 0.3rem;
      width: 1.65rem;
      height: 0.51rem;
      background-color: #f3f9fe;
      border-radius: 0.06rem;
      opacity: 0.8;
      font-family: PingFang-SC-Medium;
      font-size: 0.24rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.51rem;
      letter-spacing: 0rem;
      color: #4570f6;
    }
  }
}
.city-ul {
  margin-top: 1.9rem;
  margin-bottom: 0.4rem;
  .city-li {
    width: 6.7rem;
    height: 2.01rem;
    background-color: #fff;
    box-shadow: 0rem 1px 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.06rem;
    display: flex;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    .left-icon {
      width: 2.08rem;
      text-align: center;
      padding-top: 0.4rem;
      img {
        width: 1.17rem;
        height: auto;
        display: inline-block;
      }
    }
    .center-p {
      width: 3.48rem;
      padding-top: 0.4rem;
      .center-h1 {
        font-family: PingFang-SC-Medium;
        font-size: 0.28rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;
        padding-bottom: 0.35rem;
      }
      .center-time {
        font-family: PingFang-SC-Medium;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #808d9e;
      }
    }

    .right-icon {
      width: 0.9rem;
      padding-top: 0.14rem;
      img {
        width: 0.9rem;
        height: 0.89rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/grapher/shootCitys.vue